import React from 'react';
import WebsiteContent from '../../components/AdminNext/WebsiteContent';
import HeadLessLayout from '../../components/Layout/HeadLessLayout';

function action({ store }) {
  if (!store.getState().runtime.isAdminAuthenticated) return { redirect: '/login' };

  return {
    title: 'Website content — Bas Recovery Admin',
    component: (
      <HeadLessLayout>
        <WebsiteContent />
      </HeadLessLayout>
    )
  };
}

export default action;
